import Vue from "vue"

import("../public/common.css")
require("./mq")

///

import BootstrapVue from "bootstrap-vue"

Vue.use(BootstrapVue)
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"

///

import VueRouter from "vue-router"
Vue.use(VueRouter)

import Landing from "./pages/Landing.vue"
import Dunes from "./pages/Dunes.vue"

const routes = [
  { path: "/", component: Landing },
  { path: "/dunes", component: Dunes }
]

const router = new VueRouter({
  mode : "history",
  routes : routes,

  scrollBehavior (to, from, savedPosition) {
    if(to.hash)
      return {selector: to.hash}

    else if (savedPosition)
      return savedPosition

    return { x: 0, y: 0 }
  }
})

new Vue({
  router : router
}).$mount("#app")
